/* Timo's story copy, English.
 *
 * THIS IS THE FILE TO EDIT. Every line here is spoken out loud by Timo,
 * so write it the way it should sound, not the way it should look.
 *
 * How it plays: the story is five chapters. Each chapter is ONE text to
 * speech call, composed as
 *     [celebration or encouragement for the last word] + [chapter] + [invitation]
 * so the whole story costs five calls. That matters: the TTS layer allows
 * five calls per sixty seconds before it locks out, and caps a single call
 * at 2500 characters and silently truncates past it. Keep every chapter
 * between 500 and 700 characters and the composed line stays safe.
 *
 * Two refrains repeat word for word on purpose. A child joins in by the
 * third time they hear them, and joining in is the whole point:
 *     Timo listens. Timo waits. Timo helps.
 *     Say it with me, said Timo.
 * Do not vary them for style. Sameness is the feature.
 *
 * The four target words are what the CHILD is asked to say. They were
 * picked to be the easiest words in their chapter, not the prettiest:
 * home, nut, water, happy. All are one or two syllables and lead with
 * early developing sounds. Do not swap one for a nicer word.
 */

const storyEn = {
  'story.title': "Timo's Green Forest",
  // Timo hands the telling over to Hoppy, then the recorded story plays.
  'story.handoff': "Hey! Let me ask my friend Hoppy to tell it.",

  // ==== Chapter 1: who Timo is ====
  'story.ch1':
    'Timo lives in a big green forest. Timo is small. Timo has a soft stripy tail. ' +
    'Timo has big round ears. Big ears are good for listening. Many animals live in the forest. ' +
    'There is a big slow bear. There is a little bird. There are two hungry squirrels. ' +
    'Everybody talks at the very same time. It is so noisy. But Timo does not talk first. ' +
    'Timo listens. Timo waits. Timo helps. The forest is his home. He knows every tree. ' +
    'He knows every warm rock. He knows the best place to sit and watch the moon come up.',
  'story.invite1': 'The green forest is Timo home, say home with me.',
  'story.word1': 'home',
  'story.celebrate1': 'Home! You said it, and it made my big ears wiggle.',
  'story.encourage1': 'Home, home, the green forest is my home. Come and meet my friends.',

  // ==== Chapter 2: the two squirrels ====
  'story.ch2':
    'One day the two squirrels found a nut. It was one big brown nut. ' +
    'Both squirrels wanted that nut. They pulled it this way. They pulled it that way. ' +
    'They did not say one word. They just pulled and pulled. So Timo came and sat down. ' +
    'Timo listens. Timo waits. Timo helps. Then Timo said, tell me what you want. ' +
    'Say it with me, said Timo. The first squirrel said, I want the nut. ' +
    'The second squirrel said, I want the nut too. Now we know, said Timo. ' +
    'You can share the nut. So they broke the nut in two. Both squirrels were glad.',
  'story.invite2': 'One big brown nut for two friends, say nut with me.',
  'story.word2': 'nut',
  'story.celebrate2': 'Nut! That was lovely. Both squirrels are waving at you.',
  'story.encourage2': 'Nut, nut, one big brown nut. Now come and meet the little bird.',

  // ==== Chapter 3: the little bird, the heart of it ====
  'story.ch3':
    'Next came the little bird. He sat on a low branch. He was hot and he was thirsty. ' +
    'The bird wanted something, but the word would not come out. He opened his beak. ' +
    'Nothing came. He looked down at his feet. Nobody rushed him. ' +
    'Timo listens. Timo waits. Timo helps. Timo sat with him for a long, quiet minute. ' +
    'Then Timo said the word first, slow and soft. Water. Say it with me, said Timo. ' +
    'The bird tried. Wa. He tried again. Water. He said it! He said water! ' +
    'Timo hopped up and down. The whole green forest cheered for that little bird.',
  'story.invite3': 'The little bird found his word, say water with me.',
  'story.word3': 'water',
  'story.celebrate3': 'Water! You said it just like the bird did. I am so proud of you.',
  'story.encourage3': 'Water, water, a cool little drink of water. Come and see what happened next.',

  // ==== Chapter 4: the forest changes, Timo hears the children ====
  'story.ch4':
    'After that day the forest was different. When the bear wanted a berry, he said berry. ' +
    'When the squirrels wanted to play, they said play. When the bird was thirsty, he said water. ' +
    'Nobody pulled. Nobody pushed. Everybody had a word now. Timo was happy. ' +
    'The whole forest was happy too. Then one night Timo sat on his warm rock and looked at the moon. ' +
    'And he heard something new. Far away, past the trees, there were children. ' +
    'They had big things to say. Big, funny, wonderful things. But the words were stuck inside. ' +
    'Timo sat very still. Timo thought about the little bird.',
  'story.invite4': 'The whole green forest was happy, say happy with me.',
  'story.word4': 'happy',
  'story.celebrate4': 'Happy! That is my favourite word of all, and you said it.',
  'story.encourage4': 'Happy, happy, one happy green forest. Now come with me to the end.',

  // ==== Chapter 5: Timo comes to the child ====
  'story.ch5':
    'In the morning Timo packed a small bag. He said goodbye to the big slow bear. ' +
    'He said goodbye to the two squirrels. He said goodbye to the little bird. ' +
    'The bird sang him a song, and the song had lots of words in it. ' +
    'Then Timo walked out of the big green forest. He walked a long, long way. ' +
    'He kept his big ears open the whole time. Timo listens. Timo waits. Timo helps. ' +
    'And one day, far from the forest, he heard you. So here I am. ' +
    'I am not in the forest now. I am right here with you. ' +
    'And you have big things to say. I would love to hear them.',

  'story.ending':
    'Come back tomorrow and I will tell you about the bear and the very last berry. Goodnight, my friend.',
};

export default storyEn;
